import React from "react";
import styles from "../../components/Report/PlatformInfo.module.css";
import { IBillingDetailsResponse } from "../../hooks/patients/index.type";

interface BillingDetailsProps {
  data?: IBillingDetailsResponse;
}

export const NewRTMUsed: React.FC<BillingDetailsProps> = ({ data }) => {
  return (
    <div className={styles.rtmCard}>
      <div className={styles.rtmCardTitle}>RTM PLATFORM USED</div>
      <div className={styles.rtmTitle}>
        Therapy Engagement Software: Perspectives in Care by Sure Med Compliance{" "}
        {data?.data?.rtm_billing_report_version}.
      </div>
      <div className={styles.rtmwhitebg}>
        Patient has an established diagnosis requiring ongoing monitoring of
        therapy adherence and/or therapeutic response. Remote Therapeutic
        Monitoring services are medically necessary to support behavior-based
        treatment interventions, improve compliance, and guide clinical decision
        making. The patient has consented to participate in RTM.
      </div>
    </div>
  );
};

const NewPlatformInfo: React.FC<BillingDetailsProps> = ({ data }) => {
  const formatDate = (dateString?: string | null) => {
    if (dateString === "NA") return "N/A";
    if (!dateString) return "";
    return new Date(dateString).toLocaleDateString();
  };
  return (
    <>
      <div className={styles.card}>
        <div className={styles.question}>
          <span className={styles.label}>Interactive Communication:</span> Phone
        </div>
        <div className={styles.whitebg}>
          <span className={styles.label}>
            RTM Software Confirms 16 Days of Data Capture in Calendar Month:
          </span>{" "}
          <span className={styles.normalText}>
            {(data?.data.data.transmissionsCompletedStatus || "N/A")
              .toLowerCase()
              .replace(/^\w/, (c) => c.toUpperCase())}
          </span>{" "}
        </div>
        <div className={styles.question}>
          <span className={styles.label}>Date of Last Transmission:</span>{" "}
          {formatDate(data?.data?.data?.lastTransmissionDate) || "N/A"}{" "}
        </div>
        <div className={styles.whitebg}>
          <span className={styles.label}>Total Time Spent:</span>{" "}
          {data?.data.data.consolidatedBillingMinutes}m
        </div>
      </div>
    </>
  );
};
export default NewPlatformInfo;
